// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"3185":"baf9b41841bd07d7","8470":"ff7758ef98769f0a"}[chunkId] + ".css";
};